<div class="modal-header">
    <div>
        <h5 class="pt-4" style="padding-left:2rem"><strong>Material: </strong> {{nombre_mat}} </h5>
        <label class="pt-2 pb-2" style="padding-left:2rem"><strong>SKU: </strong> {{sku}}</label>
    </div>
    <div>   
    </div>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
  <div class="modal-body mb-4">
    <div class="row g-4">
  
      <div class="col-md-8">
      <div *ngFor="let linea_e of estacionesFiltradas" class="row">
        
          <div class="col-md-6">
            <div class="linea-card-container" [ngStyle]="{'background-color': linea_e.color}">
  
              <mat-card class="linea-card">
                <mat-card-content class="linea-content">
                  <h6 class="mb-0"><strong>Línea {{ linea_e.line }}</strong></h6>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
  
          <div class="col-md-6">
            <div class="linea-card-container" (click)="seleccionarEstacion(linea_e)" style="background-color: #ECF1F8;">
  
              <mat-card class="linea-card">
                <mat-card-content class="d-flex align-items-center justify-content-center">
                  <div class="text-center">
                    <h6><strong>{{linea_e.nombre.replace('Estacion', 'Estación')}}</strong></h6>
                    <span class="badge rounded-pill custom-bootstrap-badge ms-3">
                      {{linea_e.cantidad}}/{{linea_e.cantidad_total}}
                    </span>
                  </div>
                </mat-card-content>
              </mat-card>
  
  
            </div>
          </div>
        
      </div>
      </div>
  
  
      <div class="col-md-4 d-flex align-items-center justify-content-center border image-container img-mat"
        (mousedown)="startDrag($event)" (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()">
      
        <img [src]="image" [style.transform]="transform" draggable="false" />
      
        <div *ngIf="image != undefined" class="controls">
          <button (click)="zoomOut()"><mat-icon>zoom_out</mat-icon></button>
          <button (click)="zoomIn()"><mat-icon>zoom_in</mat-icon></button>
          <button (click)="open()"><mat-icon>open_in_full</mat-icon></button>
        </div>
      
        <label *ngIf="image == undefined" class="fw-bold text-muted">Sin imagen</label>
      
      
      </div>
  
  
    </div>
  </div>

</mat-dialog-content>


<div class="overlay" *ngIf="showModal">
    <button class="close-btn" (click)="close()">✕</button>
  <img [src]="image" />
</div>
